
import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';

const createIoPayAxiosInstance = () => {
  let config: AxiosRequestConfig = {
    baseURL: process.env.IOPAY_API_URL,
    timeout: 30000,
  };

  const instance = axios.create(config);
  
  instance.interceptors.response.use(
    (response: AxiosResponse) => {
      if (response.data?.errors && response.data?.errors.length) {
        throw {
          message: response.data.errors[0],
        };
      } else {
        return response;
      }
    },
    async (error: AxiosError) => {
      return Promise.reject(error);
    }
  );

  return instance;  
};

export default createIoPayAxiosInstance;
